import { useEffect, useState } from "react";
import { columns } from "./columns";
import { fetch } from "@/src/lib/fetch";
import { Currency } from "./model";
import { useSubscribe } from "@/src/lib/actions";
import { DataTable } from "@/src/components/ui/data-table";

export function CurrenciesTable() {
  const [currencies, setCurrencies] = useState<Currency[]>([]);

  const fetchCurrencies = () => fetch<{ data: Currency[] }>("/api/currencies").then((r) => setCurrencies(r.data));

  useEffect(() => {
    fetchCurrencies();
  }, []);

  useSubscribe("currencyUpdated ratesSynced", () => {
    fetchCurrencies();
  });

  return (
    <div className="rounded-md bg-white border">
      <DataTable columns={columns} data={currencies} />
    </div>
  );
}
